const nonBreakingSpace = '\u00A0';
const zeroWidthSpace = '\u200b';
const possibleNumberSeparators = ['.', ',', nonBreakingSpace];

const allWordsAreWithinMaxLineLength = (
  str: string,
  splitBy: string,
  maxLength: number,
): boolean => {
  const pieces = str.split(splitBy);
  return pieces.reduce(
    (shorter, piece) => shorter && piece.length <= maxLength,
    true,
  );
};

const joinWithZeroWidthSpace = (
  str1: string,
  str2: string,
  swap?: boolean,
): string => `${swap ? str2 : str1}${zeroWidthSpace}${swap ? str1 : str2}`;

const lastIndexOfChars = (str: string, chars: string[]): number =>
  chars.reduce(
    (lastCharPos, char) => Math.max(str.lastIndexOf(char), lastCharPos),
    -1,
  );

const splitOnPosition = (str: string, position: number): [string, string] => {
  const first = str.slice(0, position + 1);
  const second = str.slice(position - str.length + 1);
  return [first, second];
};

const removeCurrencySymbolIfTooLong = (
  str: string,
  subStr: string,
  maxLength: number,
): string => {
  if (str.length > maxLength) {
    return str.replace(subStr, '');
  }
  return str;
};

const amendPriceForCalendarCell = (
  formattedPrice: string,
  formattedZero: string,
): string => {
  const formattedPriceTrimmed = formattedPrice.trim();
  const formattedZeroTrimmed = formattedZero.trim();
  const maxLineLength = 5;

  if (
    allWordsAreWithinMaxLineLength(formattedPriceTrimmed, ' ', maxLineLength)
  ) {
    return formattedPriceTrimmed;
  }

  const currencySymbol = formattedZeroTrimmed.replace('0', '');
  const priceWithoutCurrencySymbol = formattedPriceTrimmed.replace(
    currencySymbol,
    '',
  );
  const priceStartsWithCurrencySymbol =
    formattedPriceTrimmed.indexOf(currencySymbol) === 0;

  if (
    currencySymbol.length <= maxLineLength &&
    priceWithoutCurrencySymbol.length <= maxLineLength
  ) {
    return joinWithZeroWidthSpace(
      priceWithoutCurrencySymbol,
      currencySymbol,
      priceStartsWithCurrencySymbol,
    );
  }

  let lastSeparatorPos = lastIndexOfChars(
    priceWithoutCurrencySymbol,
    possibleNumberSeparators,
  );
  if (lastSeparatorPos > 0) {
    if (priceStartsWithCurrencySymbol) {
      lastSeparatorPos += currencySymbol.length;
    }
    let [firstPart, secondPart] = splitOnPosition(
      formattedPriceTrimmed,
      lastSeparatorPos,
    );

    if (priceStartsWithCurrencySymbol) {
      firstPart = removeCurrencySymbolIfTooLong(
        firstPart,
        currencySymbol,
        maxLineLength,
      );
    } else {
      secondPart = removeCurrencySymbolIfTooLong(
        secondPart,
        currencySymbol,
        maxLineLength,
      );
    }
    secondPart = secondPart.replace(' ', nonBreakingSpace);

    return joinWithZeroWidthSpace(firstPart, secondPart);
  }

  return priceWithoutCurrencySymbol;
};

export { amendPriceForCalendarCell };
